var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "limits-manager" },
    [
      _c("h2", { staticClass: "limits-manager__detail-row text_large" }, [
        _vm._v(
          _vm._s(
            _vm.i18n.lim_change_limits_title({
              assetName: _vm.assetName,
              asset: _vm.request.tokenCode
            })
          )
        )
      ]),
      _vm._v(" "),
      _vm.view.mode === _vm.VIEW_MODES.upload
        ? [
            _c("detail", {
              staticClass: "text_medium limits-manager__detail-row",
              attrs: {
                prop: _vm.i18n.lbl_request_creation_date(),
                value: _vm.i18n.d(_vm.request.createdAt)
              }
            }),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.i18n.lim_requirements_title()))]),
            _vm._v(" "),
            _vm._l(_vm.documents, function(item, i) {
              return _c(
                "div",
                { key: i, staticClass: "limits-manager__document-wrapper" },
                [
                  _c("detail", {
                    staticClass: "text_medium limits-manager__detail-row",
                    attrs: {
                      prop: _vm.i18n.lbl_document_type(),
                      value: item.label
                    }
                  }),
                  _vm._v(" "),
                  _c("detail", {
                    staticClass: "text_medium limits-manager__detail-row",
                    attrs: {
                      prop: _vm.i18n.lbl_note(),
                      value: item.description
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "limits-manager__file-field-wrapper" },
                    [
                      _c("file-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "limits-manager__file-field",
                        attrs: {
                          name: "limits-proof-of-income",
                          type: _vm.documentTypes.limitsProofOfIncome,
                          label: _vm.i18n.lbl_select_files(),
                          id: i + "-limits-document",
                          fileType: "image"
                        },
                        model: {
                          value: _vm.documents[i].file,
                          callback: function($$v) {
                            _vm.$set(_vm.documents[i], "file", $$v)
                          },
                          expression: "documents[i].file"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-wrap" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "btn md-primary",
                    attrs: { disabled: _vm.isPending },
                    on: { click: _vm.submit }
                  },
                  [_vm._v(_vm._s(_vm.i18n.lim_change_limits()))]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.view.mode === _vm.VIEW_MODES.pending
        ? [
            _c("h3", { staticClass: "limits-manager__detail-row text_large" }, [
              _vm._v(_vm._s(_vm.operationType))
            ]),
            _vm._v(" "),
            _c("detail", {
              staticClass: "limits-manager__limit-row",
              attrs: {
                prop: _vm.i18n.lim_daily(),
                value: _vm.request.details.limits.dailyOut
              }
            }),
            _vm._v(" "),
            _c("detail", {
              staticClass: "limits-manager__limit-row",
              attrs: {
                prop: _vm.i18n.lim_weekly(),
                value: _vm.request.details.limits.weeklyOut
              }
            }),
            _vm._v(" "),
            _c("detail", {
              staticClass: "limits-manager__limit-row",
              attrs: {
                prop: _vm.i18n.lim_monthly(),
                value: _vm.request.details.limits.monthlyOut
              }
            }),
            _vm._v(" "),
            _c("detail", {
              staticClass: "limits-manager__limit-row",
              attrs: {
                prop: _vm.i18n.lim_annual(),
                value: _vm.request.details.limits.annualOut
              }
            }),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.i18n.lim_pending_request_msg()))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-wrap" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "btn md-primary",
                    attrs: { disabled: _vm.isPending },
                    on: {
                      click: function($event) {
                        return _vm.$emit(_vm.commonEvents.closeRequestEvent)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.i18n.lbl_ok()))]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38dcc172", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38dcc172","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/limits/Limits.DocumentsUploader.vue
// module id = 2buO
// module chunks = 1